import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="filter"
export default class extends Controller {
  static targets = ["input", "item"];

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim();

    this.itemTargets.forEach((item) => {
      const name = (item.dataset.filterName || "").toLowerCase();
      const handle = (item.dataset.filterHandle || "").toLowerCase();

      const matches =
        query === "" || name.includes(query) || handle.includes(query);

      item.style.display = matches ? "" : "none";
    });
  }

  clear() {
    this.inputTarget.value = "";
    this.filter();
  }
}
